export default __webpack_public_path__ + "static/media/planimg1.1a070cea.png";